import React from 'react';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { TechniquesList } from '../components/techniques_list/techniques_list';

const StylesPage = () => {
  return (
    <ScrollToTop>
      <section>
        <TechniquesList />
      </section>
    </ScrollToTop>
  );
};
export default StylesPage;
